module.exports = __webpack_public_path__ + "img/step1_zh-CN.d0278454.png";